import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getMessages } from '../actions';

const useSendMessages = () => {
  const dispatch = useDispatch();

  const { candidateId, haveMessages } = useSelector<any, any>(state => state.modal.data);

  const loading = useSelector<any, any>(state => state.loading);

  const getMessagesHandler = useCallback(() => dispatch(getMessages({ candidateId })), [
    candidateId,
    dispatch,
  ]);

  useEffect(() => {
    if (!haveMessages) {
      getMessagesHandler();
    }
  }, [getMessagesHandler, haveMessages]);

  const messages = useSelector<any, any>(state => state.messages);

  return { candidateId, loading, messages };
};

export default useSendMessages;
